<template>
	<div>
		<!-- 编辑界面 -->
		<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" class="margin_top_40" :wrapper-closable="false" :modal="false" :destroy-on-close="true" @click="closeDialog">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" inline>
				<el-form-item label="按钮名称" prop="menuName">
					<el-input clearable v-model="editForm.menuName" class="input_200px" size="small" auto-complete="off" placeholder="请输入按钮名称"></el-input>
				</el-form-item>
				<el-form-item label="权限编号" prop="menuCode">
					<el-input clearable v-model="editForm.menuCode" class="input_200px" size="small" auto-complete="off" placeholder="请输入权限编号"></el-input>
				</el-form-item>
				<el-form-item label="按钮位置" prop="menuPath">
					<el-input clearable v-model="editForm.menuPath" class="input_200px" size="small" auto-complete="off" placeholder="请输入按钮位置"></el-input>
				</el-form-item>
				<el-form-item label="显示顺序" prop="seq">
					<el-input v-model.number="editForm.seq" class="input_200px" size="small" auto-complete="off" placeholder="请输入显示顺序"></el-input>
				</el-form-item>
				<!-- <el-form-item label="是否上线" prop="isOnLine">
					<el-switch v-model="editForm.isOnLine" active-color="#13ce66" inactive-color="#d8d8d8">
					</el-switch>
				</el-form-item></br> -->
				<!-- <el-form-item label="是否显示" prop="isShow">
					<el-switch v-model="editForm.isShow" active-color="#13ce66" inactive-color="#d8d8d8">
					</el-switch>
				</el-form-item> -->
				<el-form-item label="图标" prop="icon">
					<el-popover ref="popover" placement="bottom" trigger="click" width="450">
						<template #reference>
							<span class="one_01">
								<i :class="userChooseIcon" class="" style="font-size: 40px"></i>
								{{ chooseIcons }}
							</span>
						</template>
						<div class="iconList">
							<i v-for="item in iconList" :key="item" :class="item" style="font-size: 30px" @click="setIcon(item)"></i>
						</div>
					</el-popover>
				</el-form-item>
				<el-form-item label="颜色" prop="menuColor">
					<div style="display: flex; align-items: center">
						<el-select v-model="editForm.menuColor" size="small" class="input_200px" placeholder="请选择">
							<el-option v-for="(item, index) in btnType" :key="index" :label="item.text" :value="item.code"></el-option>
						</el-select>
						<!-- <el-color-picker v-model="editForm.menuColor"></el-color-picker> -->
					</div>
				</el-form-item>
				<div>
					<el-form-item label="按钮预览" prop="icon">
						<el-button size="small" :type="editForm.menuColor" :icon="editForm.menuIcon">
							{{ editForm.menuName.split("-")[0] }}
						</el-button>
					</el-form-item>
				</div>
			</el-form>
			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
				<el-button :disabled="editForm.keyId === ''" size="small" type="danger" icon="el-icon-delete" :loading="saveloading" class="title" @click="deleteMenu">删除</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { GetMenuByKeyId, SaveMenu, DeleteMenu } from "../../../api/menuApi.js";
import { elementIcons } from "../../../utils/icon.js";
export default {
	props: [],
	data() {
		return {
			saveloading: false,
			treeExpandData: [],
			checkedKeyArray: [],
			iconList: [],
			userChooseIcon: "",
			chooseIcons: "",
			title: "",
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				menuCode: "",
				menuName: "",
				menuPath: "",
				parentKeyId: "",
				isOnLine: true,
				isShow: true,
				menuIcon: "",
				menuColor: "primary",
				seq: 0,
				menuType: 1,
				menuLevel: 3
			},
			btnType: [
				{ code: "primary", text: "primary" },
				{ code: "success", text: "success" },
				{ code: "warning", text: "warning" },
				{ code: "danger", text: "danger" },
				{ code: "info", text: "info" },
				{ code: "", text: "normal" }
			],
			// rules表单验证
			rules: {
				menuCode: [
					{
						required: true,
						message: "请输入模块编号",
						trigger: "blur"
					}
				],
				menuName: [
					{
						required: true,
						message: "请输入模块名称",
						trigger: "blur"
					}
				],
				menuPath: [
					{
						required: true,
						message: "请输入模块地址",
						trigger: "blur"
					}
				]
			},
			styleForm: {
				color: "",
				radius: 40
			}
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {
		this.iconList = elementIcons;
	},
	mounted() {},
	methods: {
		changeRadius() {},
		changeRadius() {},
		setIcon(icon) {
			this.editForm.menuIcon = icon;
			this.userChooseIcon = icon; //将i的样式设为选中的样式el-icon-xxx
			this.chooseIcons = "";
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.$refs["editForm"].resetFields();
			this.editFormVisible = false;
		},
		//显示编辑界面
		editShow(row, type) {
			this.userChooseIcon = "";
			if (type === "edit") {
				this.title = "编辑";
				let parmar = {
					keyId: row.keyId
				};
				GetMenuByKeyId(parmar)
					.then((res) => {
						if (res.data) {
							this.userChooseIcon = res.data.menuIcon;
							this.editForm = res.data;
						}
					})
					.catch((err) => {
						this.$message.error("加载失败，请稍后再试！");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editForm.parentKeyId = row.keyId;
			}
			this.editFormVisible = true;
			this.$nextTick(() => {
				this.$refs.popover.$refs.popper.setAttribute(this.$options._scopeId, "");
			});
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveMenu(this.editForm)
						.then((res) => {
							this.loading = false;
							if (res.code === 1) {
								this.editFormVisible = false;
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "保存成功！"
								});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},

		// 删除
		deleteMenu() {
			this.$confirm("确定要删除<" + this.editForm.menuName + ">吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyIds: [this.editForm.keyId]
				};
				DeleteMenu(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.editFormVisible = false;
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		}
	}
};
</script>
<style scoped>
.iconList {
	width: 400px;
	height: 300px;
	overflow-y: scroll;
	overflow-x: hidden;
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
}

.iconList i {
	display: inline-block;
	width: 60px;
	height: 45px;
	color: #000000;
	font-size: 20px;
	border: 1px solid #e6e6e6;
	border-radius: 4px;
	cursor: pointer;
	text-align: center;
	line-height: 45px;
	margin: 5px;
}

.iconList i:hover {
	color: aquamarine;
}

.el-popover__reference {
	border: 1px dashed #5b5b5b;
	text-align: center;
}

.el-switch__core {
	width: 40px !important;
}

.one_01 {
	display: inline-block;
	width: 198px;
	height: 40px;
	line-height: 40px;
}

.el-popover {
	max-width: 400px;
}
</style>
